import React, { useState, useEffect, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import RegistrationForm from './components/RegistrationForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isApplicationClosed, setIsApplicationClosed] = useState(false);
  
  // Application deadline: September 10th, 2025
  const applicationDeadline = useMemo(() => new Date('2025-09-10T23:59:59'), []);
  
  // Check if application is closed and countdown timer
  useEffect(() => {
    const now = new Date();
    if (now > applicationDeadline) {
      setIsApplicationClosed(true);
    }
    
    // Update countdown every second
    const timer = setInterval(() => {
      const currentTime = new Date();
      if (currentTime > applicationDeadline) {
        setIsApplicationClosed(true);
        clearInterval(timer);
      } else {
        const timeLeft = applicationDeadline - currentTime;
        if (timeLeft > 0) {
          const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
          setCountdown({ days, hours, minutes, seconds });
        }
      }
    }, 1000);
    
    return () => clearInterval(timer);
  }, [applicationDeadline]);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<RegistrationForm />} />
          </Routes>
        </main>
        <Footer countdown={countdown} isApplicationClosed={isApplicationClosed} />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;
